import styled, { css } from "styled-components";

export const ScheduleContainer = styled.div`
  max-width: 800px;
  margin: 0px auto;
  .ant-form-item-explain {
    color: white;
  }
`;

export const ScheduleFormContainer = styled.div`
  position: relative;
  display: flex;
  height: 100%;
`;

export const ScheduleFormContent = styled.div`
  position: absolute;
  bottom: -20px;
  z-index: 1;
  box-shadow: 0px 7px 10px #00000070;

  @media only screen and (max-width: 768px) {
    position: static;
    width: 100%;
    bottom: unset;
  }
`;

export const ImageContainer = styled.div`
  position: relative;

  &:before {
    content: " ";
    position: absolute;
    top: 10%;
    left: 2.5%;
    width: 95%;
    height: 80%;
    z-index: 1;
    ${({ theme }) => css`
      border: 3px solid ${theme.colors.darkGray2};
    `}
  }
  @media only screen and (max-width: 768px) {
    &:before {
      top: 2.5%;
      left: 5%;
      width: 90%;
      height: 95%;
    }
  }
`;
